import makeForm from 'ui/forms';

export const makeModalForm = <Fields,>() => makeForm<Fields>({ modal: true });

export default makeModalForm;
